import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export const useNavigateWithQuery = () => {
  const navigate = useNavigate() as (path: string, options?: { replace?: boolean; state?: any }) => void;
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return (path: string, options?: { replace?: boolean; state?: any }) => {
    const mailToken = searchParams.get("mail_token");
    const trackerId = searchParams.get("trackerId");

    const url = new URLSearchParams();

    if (mailToken) url.set("mail_token", mailToken);
    if (trackerId) url.set("trackerId", trackerId);

    const currentParams = new URLSearchParams(location.search);
    currentParams.forEach((value, key) => {
      if (!url.has(key)) {
        url.set(key, value);
      }
    });

    const fullPath = path.split("?")[0] + "?" + url.toString();

    navigate(fullPath, options);
  };
};